import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import { LinkInformation, Links } from "./Links";
import { RTF } from "./RTF";

export const CarouselThumbnailLink: React.FC<{
  title: string;
  tagline?: string | null;
  message?: IRichTextInformation | null;
  image?: IGatsbyImageData | null;
  alt?: string | null;
  links?: Array<LinkInformation>;
  className?: string;
  date?: string | null;
}> = (props) => {
  const { title, image, alt, links, message, date, tagline } = props;
  const linksAreButtons: boolean = links
    ? links.some((link) => link.showLinkAsButton)
    : false;

  return (
    <section
      data-component="Carousel Thumbnail Link"
      className="flex w-full flex-col"
    >
      <span className={classNames("h6 text-hyacinth", "mb-20px")}>
        {tagline}
      </span>
      {title && <h3 className={classNames("h3", "mb-20px")}>{title}</h3>}
      {date && <p className="p4 mb-20px">{date}</p>}
      {image && (
        <div className="mb-20px w-full">
          <GatsbyImage
            objectFit="cover"
            image={image}
            alt={alt ?? ""}
            className="aspect-h-4 aspect-w-5 w-full"
            loading="lazy"
          />
        </div>
      )}
      {message && <RTF className="relative mb-40px w-4/5" content={message} />}
      {links && (
        <Links
          links={links}
          className={linksAreButtons ? "servicesButton" : ""}
        />
      )}
    </section>
  );
};
